const config = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api.cciahn.org/v1"
      : "http://localhost:4000/v1",
};

export default config;
